import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";

export class ValdnWidgetsDateModel extends WidgetsAbstract {
    readonly icon: string = 'fact_check';
    readonly name: string = 'Date';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.VALDN_DATE;
    template: string = `{
        "name": "date",
        "options": {
          "data": {
            "condition": "<=",
            "left": "from",
            "right": "to"
          },
          "errorPath": "from"
        }
      }`;
    readonly badge: string = 'VD';
    readonly placeholderClassName: string = 'valdn-placeholder';

    type: string = 'valdn';
    
    cloneFrom(origin: WidgetsAbstract) : WidgetsAbstract {
      return this;
  }     
}
